import personDataService = require("../core/persons.dataservice");

export function initialize(module: ng.IModule) {
    module.controller("PersonsEditController", PersonsEditController);

    PersonsEditController.$inject = ["$log", "personDataService", "person", "serviceConfig", "$rootScope", "$state", "$mdDialog"];
}

function PersonsEditController(
    $log: ng.ILogService,
    personDataService: personDataService.IPersonDataService,
    person,
    serviceConfig,
    $rootScope: ng.IRootScopeService,
    $state: ng.ui.IStateService,
    $mdDialog: ng.material.IDialogService) {
    
    var vm = this;
    vm.person = person.entity;
    vm.save = save;
    vm.cancelChanges = cancelChanges;
    vm.webApiUrl = serviceConfig.webApiUrl;
    vm.selectPersonImage = selectPersonImage;
    vm.deletePersonImage = deletePersonImage;
    vm.addPersonImage = addPersonImage;

    vm.imageFile = <File> null;
    vm.imageSource = vm.webApiUrl + "PersonService/" + vm.person.Id + "/PersonImage?ImageRv=" + encodeURIComponent(vm.person.ImageFileRv); // {{vm.webApiUrl}}PersonService/{{vm.person.Id}}/PersonImage" alt="Picture of {{vm.person.Name}}
    vm.deleteImage = false;

    vm.directiveapi = {};
    
    activate();

    var stateChangedListener = $rootScope.$on('$stateChangeStart', onStateChange);

    function activate() {
        $log.info("Persons Edit Controller up and running...");
    }

    function onStateChange(event, _toState, _toParams, _fromState, _fromParams) {

        // The person has changes, and we are navigating away from this view
        if (vm.person.entityAspect.entityState.name === 'Modified') {
            event.preventDefault();
            showAlert("Person has changed", "Please save or discard the changes before continuing.");
        }
        else {
            // Clean up - unsubscribe the event handler
            stateChangedListener();
        }
    }

    function save() {
        personDataService
            .save(vm.person)
            .then(() => {
                $log.info("Successfully saved person");
                if (vm.imageFile) {
                    personDataService
                        .savePersonImage(vm.imageFile, vm.person.Id)
                        .then(() => {
                        $log.info("Successfully saved person image");
                        goToDetailsPage();
                    })
                        .catch(err => $log.error("Could not save Person image, error occured: " + err));
                }
                else if (vm.deleteImage) {
                    personDataService
                        .deletePersonImage(vm.person.Id)
                        .then(() => {
                        $log.info("Successfully deleted person image");
                        goToDetailsPage();
                        })
                        .catch(err => $log.error("Could not delete Person image, error occured: " + err));
                }
                else {
                    goToDetailsPage();
                }
            })
            .catch(err => $log.error("Could not save Person, error occured: " + err));
        
    }

    function cancelChanges() {
        vm.person.entityAspect.rejectChanges();
        goToDetailsPage();
    }

    function goToDetailsPage() {
        $state.go("app.resources.persons.detail", {"personId": vm.person.Id});
    }

    function showAlert(title: string, content: string) : ng.IPromise<any> {
        var confirm = $mdDialog.alert()
            .title(title)
            .textContent(content)
            .ok('Ok');
        
        return $mdDialog.show(confirm)
    }

    function selectPersonImage(file: File) {
        if (file.size > 2 * 1024 * 1024) { // 2 mb
            showAlert("File to big", "Maximum allowed file size is 2mb.");
            return;
        };
        vm.deleteImage = false;
        vm.imageFile = file;
        var reader = new FileReader();
        reader.onload = (ev) => {
            if (!vm.deleteImage) {
                vm.imageSource = (<any>ev.target).result;
            }
            $rootScope.$apply();
        };
         //= (function (aImg) { return function (e) { aImg.src = e.target.result; }; })(img);
        reader.readAsDataURL(file);
        
        //file.
        //var tst = 123;
    };

    function deletePersonImage() {
        vm.deleteImage = true;
        vm.imageFile = null;
        vm.imageSource = "#";
        //$rootScope.$apply();
    };

    function addPersonImage() {
        //angular.element($element)
        vm.directiveapi.click();
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons.edit.controller.ts